enum userRoles {
    removed = 500,
    guest = 1000, 
    custommer = 2000, 
    seller = 3000, 
    administrator = 4000, 
    sudo = 5000
}
export default userRoles;